<template>
<div>
    <meeting-and-event-list
        :event-type="eventType"
    />
</div>
</template>
    
<script>
import { ref, onUnmounted } from "@vue/composition-api";
import MeetingAndEventList from '../components/event-list/EventList.vue'

export default {
    components: {
        MeetingAndEventList
    },
    setup() {
        const eventType = ref('meetings&events')

        return {
            eventType,
        }
    }
}
</script>